import { ActivityPointRankMyDto } from '@diritto/common/activityPoint/dtos/activity-point.dtos';
import { ProfileLiteRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { ProfileRanking, ProfileRankingStatus } from 'app-components/ranking/activityPoint/ProfileRanking';
import styled from '@emotion/styled';
import React from 'react';

export const AllRankingList = ({
  myRank,
  activityPointAllRank,
  profileLites,
}: {
  myRank?: ActivityPointRankMyDto;
  activityPointAllRank: ActivityPointRankMyDto[];
  profileLites: Record<string, ProfileLiteRelayDto>;
}) => {
  const showMyRankOnOutsideList =
    myRank && ((myRank.rank && myRank.rank > activityPointAllRank.length) || !myRank.rank);

  return (
    <StyledMyRankingListWrapper>
      {activityPointAllRank.map(rank => (
        <ProfileRanking
          key={rank.profileId}
          activityPointMyRank={rank}
          status={
            myRank?.profileId === rank.profileId
              ? ProfileRankingStatus.InnerRankLimitMyProfile
              : ProfileRankingStatus.InnerRankLimit
          }
          profileLite={profileLites[rank.profileId]}
        />
      ))}
      {showMyRankOnOutsideList && (
        <ProfileRanking
          key={myRank.profileId}
          activityPointMyRank={myRank}
          status={ProfileRankingStatus.OuterRankLimit}
          profileLite={profileLites[myRank.profileId]}
        />
      )}
    </StyledMyRankingListWrapper>
  );
};

const StyledMyRankingListWrapper = styled.div`
  margin-top: 24px;
`;
